import { render, staticRenderFns } from "./ClosedPeriodSettings.vue?vue&type=template&id=0f49216e&"
import script from "./ClosedPeriodSettings.vue?vue&type=script&lang=js&"
export * from "./ClosedPeriodSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports